<section id="pageCover" class="row">
    <img src="../../../assets/images/contactCover.png" alt="" class="pageCover">
    <!--<div class="row pageTitle">Projects</div>-->
    <div class="row pageBreadcrumbs">
        <!--<ol class="breadcrumb">
            <li><a href="index.html">home</a></li>
            <li class="active">Projects</li>
        </ol>-->
    </div>
</section>

<section id="latestPosts" class="row">
    <div class="container">
        <!--<div class="row sectionTitles">
            <h2 class="sectionTitle">
                Key Staff
            </h2>
           
        </div>-->
        <div class="row">

            <img src="../../../../assets/images/Team.png" width="100%" />


        </div>
    </div>
</section>